import { CheckCircle, ContentCopyOutlined } from "@mui/icons-material"
import { Fade, Grid, Input, Typography } from "@mui/material"
import { useState } from "react"
import { Link } from "react-router-dom"
import { TelegramIcon, XOutlineIcon } from "../../assets"
import { customPaletteColors } from "../../themes/common"
import { Button, StyledPaper, socialLinks } from "../commons"
import StatsBox, { StatsBoxType } from "../commons/StatsBox"
import useGlobalStore from "../../stores/global"

const statsBoxPlaceHolder: StatsBoxType[] = [
  { title: 'Referral Points', content: '0', type: 'number', minDecimals: 0 },
  { title: 'Friends Referred', content: '0', type: 'number', minDecimals: 0 },
]


const MyReferralTableContent = () => {
  const [copied, setCopied] = useState(false)
  const referrerData = useGlobalStore((state) => state.referrerData)
  const referralLink = `https://app.intersect.com?/referral=${referrerData?.referralCode}`
  const handleCopyLink = () => {
    console.log("triggered")
    navigator.clipboard.writeText(referralLink)
    setCopied(true)
    setTimeout(() => {
      setCopied(false)
    }, 4000)
  }
  return (
    <Grid spacing={3} item container justifyContent={'space-between'} alignItems={'center'} sx={{ padding: '0.5rem 1.5rem' }}>
      <Fade in={true} timeout={800}>
        <Grid item sx={{ maxWidth: '100%' }} xs={12}>
          <Typography variant="h4">Refer Friends. Earn More Points.</Typography>
        </Grid>
      </Fade>
      <Fade in={true} timeout={1200}>
        <Grid item container xs={12} md={6} gap={1}>
          <Typography color="text.secondary" variant="body5">Refer Friends and EARN <Typography variant="body5" color="brand.primary" component={"span"}>15% of their total points.</Typography>
          </Typography>
          <Grid item container flexWrap={'nowrap'} alignItems={'center'}>
            <Input
              type="string"
              value={""}
              inputProps={{
                min: 0
              }}
              placeholder={referralLink} sx={{
                width: '100%',
                maxWidth: '20rem',
                backgroundColor: 'background.translucent',
                borderRadius: '8px 0px 0px 8px',
                border: `1px solid`,
                borderColor: 'background.border',
                padding: '0.2rem 0.5rem',
                margin: '0rem 0rem',
                height: '2.4rem',
                fontSize: '0.8rem'
              }} />
            <Grid item sx={{ height: '100%' }}>
              <StyledPaper color='primary' sx={{ padding: { xs: '0.64rem 0.6rem', sm: '0.2rem 0.6rem' }, placeContent: 'center', height: '100%', borderRadius: '0px 8px 8px 0px' }}>
                <Grid container gap={0.5} alignItems={'center'} flexWrap={'nowrap'} onClick={() => handleCopyLink()}>
                  {
                    copied ? <CheckCircle sx={{ padding: '0.2rem', cursor: 'pointer', color: 'brand.primary' }} />
                      : <ContentCopyOutlined sx={{ padding: '0.2rem', cursor: 'pointer', color: 'brand.primary' }} />
                  }
                </Grid>
              </StyledPaper>
            </Grid>
            <Button
              color="secondary"
              variant='contained'
              sx={{ padding: '1rem', minWidth: '3rem', height: '2.4rem', marginLeft: '1rem' }}>
              <Link style={{ color: customPaletteColors.brand.primary, textDecoration: 'none' }}
                target='_blank' to={`${socialLinks.discord}`}>
                <Grid container alignItems={'center'} justifyItems={'center'}>
                  <XOutlineIcon />
                </Grid>
              </Link>
            </Button>
            <Button
              color="secondary"
              variant='contained'
              sx={{ padding: '1rem', minWidth: '3rem', height: '2.4rem', marginLeft: '1rem' }}>
              <Link style={{ color: customPaletteColors.brand.primary, textDecoration: 'none' }}
                target='_blank' to={`${socialLinks.telegram}`}>
                <Grid container alignItems={'center'} justifyItems={'center'}>
                  <TelegramIcon style={{ marginLeft: '-0.2rem' }} />
                </Grid>
              </Link>
            </Button>
          </Grid>
        </Grid>
      </Fade>
      <Grid item container xs={6} gap={2} flexWrap={'nowrap'} justifyContent={'flex-end'}>
        {
          statsBoxPlaceHolder.map((statsBox, index) => {
            return (
              <Fade in={true} timeout={1200 * (index + 1)} key={index}>
                <Grid item xs={6} key={index} sx={{ xs: { maxWidth: '100%' } }} style={{ maxWidth: '40%' }}>
                  <StatsBox {...statsBox} />
                </Grid>
              </Fade>
            )
          })
        }
      </Grid>
    </Grid>
  )
}

export default MyReferralTableContent